export default "__VITE_ASSET__BmB2QTdT__"